import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { Link, Stack } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface SubmissionHeaderNavigationProps {
  tenantId: string;
}

export function SubmissionHeaderNavigation({
  tenantId,
}: SubmissionHeaderNavigationProps) {
  return (
    <Stack
      id="submission-header"
      paddingX={3}
      paddingY={2}
      sx={{
        backgroundColor: "background.paper",
        borderBottom: "1px solid",
        borderBottomColor: "divider",
      }}
    >
      <Link
        component={RouterLink}
        to={`/o/${tenantId}/waste/submissions`}
        sx={{
          textDecoration: "none",
          color: "primary.main",
          display: "inline-flex",
          alignItems: "center",
          fontSize: "14px",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        <ChevronLeftIcon sx={{ mr: 0.5, fontSize: 18 }} />
        ALL SUBMISSIONS
      </Link>
    </Stack>
  );
}
